import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/opt/buildhome/repo/frontend/node_modules/next/dist/client/app-dir/link.js");
